<template>
  <div class="whiteBG radius pt-md-3">
    <div class="row justify-content-center d-flex">
      <div class="col-12 col-md-12"> 
          <div class="PlatformOuter border radiusbold mb-3 d-flex align-items-center mt-md-4"> 
            <div class="platformico w-25 p-3 border-right text-center mr-md-3">
              <img src="../../../../static/fxView/images/platforn-icon-1.svg" alt="MT4">
              <h3 class="mb-3">{{$t('download')}} <span class="ml-md-1">{{$t('MT4')}}</span></h3>
            </div>
            <div class="platfromdownload text-center w-75 d-flex align-items-center justify-content-start">
              <div class="downloadPlatformList">
                <a title="Windows" @click="handleMt4Event('windows')" href="https://download.mql5.com/cdn/web/charlgate.ltd/mt4/fxview4setup.exe" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/windows.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forWindows')}}
                    <!-- {{$t('window')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a title="IOS" @click="handleMt4Event('ios')" href="https://download.mql5.com/cdn/mobile/mt4/ios?server=FxView-Demo,FxView-Live" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/ios.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forIos')}}
                    <!-- {{$t('launch')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">  
                <a title="Android" @click="handleMt4Event('android')" href="https://download.mql5.com/cdn/mobile/mt4/android?server=FxView-Demo,FxView-Live" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/android.svg" alt="Icon">  
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forAndroid')}}
                    <!-- {{$t('launch')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <!-- :to="'/web-trade-link'" -->
                <a @click="handleMt4Event('webtrade')" href="" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/webtrader.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('MT4WebTrader')}}
                  </div>
                </a>
              </div>
            </div> 
          </div>
          <!-- downloadplatform end -->

          <!-- <div class="PlatformOuter border radiusbold mb-3 d-flex align-items-center mt-md-4"> 
            <div class="platformico w-25 p-3 border-right text-center mr-md-3">
              <img src="../../../../static/fxView/images/platforn-icon-3.svg" alt="MT5">
              <h3 class="mb-3">{{$t('download')}} <span class="ml-md-1">{{$t('MT5')}}</span></h3>
            </div>
            <div class="platfromdownload text-center w-75 d-flex align-items-center justify-content-start">
              <div class="downloadPlatformList">
                <a title="Windows" @click="handleMt5Event('windows')" href="https://download.mql5.com/cdn/web/fxview.uk.ltd/mt5/fxview5setup.exe" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/windows.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forWindows')}}
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a title="IOS" @click="handleMt5Event('ios')" href="https://apps.apple.com/us/app/metatrader-5/id413251709" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/ios.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forIos')}}
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a title="Android" @http://10.10.11.247:4018click="handleMt5Event('android')" href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/android.svg" alt="Icon">  
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forAndroid')}}
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a  @click="handleMt5Event('demoTrader')" href="https://mt5demo.fxview.com/terminal" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/webtrader.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    MT5 Demo Web Trader 
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a  @click="handleMt5Event('liveTrader')" href="https://mt5live.fxview.com/terminal" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/webtrader.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    MT5 Live Web Trader
                  </div>
                </a>
              </div>
            </div> 
          </div> -->
          <!-- downloadplatform end -->

          <div class="PlatformOuter border radiusbold mb-3 d-flex align-items-center mt-md-4"> 
            <div class="platformico w-25 p-3 border-right text-center mr-md-3">
              <img src="../../../../static/fxView/images/platforn-icon-2.svg" alt="MT5">
              <h3 class="mb-3">{{$t('download')}} <span class="ml-md-1" v-html="$t('actTrader')"></span></h3>
            </div>
            <div class="platfromdownload text-center w-75 d-flex align-items-center justify-content-start">
              <div class="downloadPlatformList">
                <a title="Windows" @click="handleActEvent('windows')" href="http://setup.sysfx.com/setup/trader/fxview/trader_setup.exe" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/windows.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forWindows')}}
                    <!-- {{$t('window')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a title="IOS" @click="handleActEvent('ios')" href="https://apps.apple.com/us/app/acttrader/id6478274395?uo=2" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/ios.svg" alt="Icon">
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forIos')}}
                    <!-- {{$t('launch')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <a title="Android" @click="handleActEvent('android')" href="https://play.google.com/store/apps/details?id=com.acttrader&hl=e" target="_blank">
                  <div class="thumb d-block mb-2">
                    <img class="mr-md-3" src="../../../../static/fxView/images/android.svg" alt="Icon">  
                  </div>
                  <div class="font-weight-normal mb-0">
                    {{$t('forAndroid')}}
                    <!-- {{$t('launch')}} -->
                  </div>
                </a>
              </div>
              <div class="downloadPlatformList">
                <div class="thumb d-block mb-2">
                  <img class="mr-md-3" src="../../../../static/fxView/images/webtrader.svg" alt="Icon">
                </div>
                <div class="font-weight-normal mb-0">
                  {{$t('ActWebTrader')}}  
                  <div>
                    <a title="Act Web Trader Live" @click="handleActEvent('liveTrader')" href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245" target="_blank">{{$t('live')}}  </a>
                    <a title="Act Web Trader Demo" @click="handleActEvent('demoTrader')" href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" target="_blank">{{$t('demo')}}  </a>
                  </div>
                </div>      
              </div>
            </div> 
          </div>
          <!-- downloadplatform end -->
 
      </div>
    </div>
  </div> 
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Download platform',
         
        data() {
            return {
                
            }
        },
        methods:{

          handleMt4Event(event){
            switch (event) {
              case 'windows':
                this.$trackEvent('CP+Download+MT4', 'For Windows', 'edition');
                break;
              case 'ios':
                this.$trackEvent('CP+Download+MT4', 'For iOS', 'edition');
                break;
              case 'android':
                this.$trackEvent('CP+Download+MT4', 'For Andriod', 'edition');
                break;
              case 'webtrade':
                this.$trackEvent('CP+Download+MT4', 'MT4 Web Trader', 'edition');
                this.$router.push('/new-web-trade-link')
                break;
              // default:
              //   this.result = 'Invalid button';
            }
          },

          handleMt5Event(event){
            switch (event) {
              case 'windows':
                this.$trackEvent('CP+Download+MT5', 'For Windows', 'edition');
                break;
              case 'ios':
                this.$trackEvent('CP+Download+MT5', 'For iOS', 'edition');
                break;
              case 'android':
                this.$trackEvent('CP+Download+MT5', 'For Andriod', 'edition');
                break;
              case 'demoTrader':
                this.$trackEvent('CP+Download+MT5', 'MT5 Demo Web Trader', 'edition');
                break;
              case 'liveTrader':
                this.$trackEvent('CP+Download+MT5', 'MT5 Live Web Trader', 'edition');
                break;
            }
          },

          handleActEvent(event){
            switch (event) {
              case 'windows':
                this.$trackEvent('CP+Download+ActTrader', 'For Windows', 'edition');
                break;
              case 'ios':
                this.$trackEvent('CP+Download+ActTrader', 'For iOS', 'edition');
                break;
              case 'android':
                this.$trackEvent('CP+Download+ActTrader', 'For Andriod', 'edition');
                break;
              case 'demoTrader':
                this.$trackEvent('CP+Download+ActTrader', 'Demo', 'edition');
                break;
              case 'liveTrader':
                this.$trackEvent('CP+Download+ActTrader', 'Live', 'edition');
                break;
            }
          }
            
        },
        mounted() { 
            
        },
    }
</script>
 



// WEBPACK FOOTER //
// src/components/fxView/users/downloadplatform.vue